// #region Dependencias
import { useState, useEffect } from 'react'
import styled from 'styled-components'
// #endregion

// #region Estilos
const StyledContainer = styled.div`
  height: 0;
  padding-bottom: 56.25%; /* 16:9 */
  position: relative;
  width: 100%;
`

const StyledIFrame = styled.iframe`
  background-color: black;
  border: 0;
  height: 100%;
  left: 0;
  pointer-events: none;
  position: absolute;
  top: 0;
  user-select: none;
  width: 100%;
`
// #endregion

/**
 * Componente para mostrar un reproductor de video embebido de YouTube.
 * @class
 * @param {Object} props - Propiedades del componente.
 * @param {string} props.video - URL del video de YouTube a mostrar.
 * @param {boolean} props.mostrarVideo - Valor que indica si el video se está mostrando.
 * @param {Function} props.setMostrarVideo - Función para actualizar el estado de mostrarVideo.
 */
const VideoPlayer = ({ video, mostrarVideo, setMostrarVideo, ...props }) => {
  const [videoEmbed, setVideoEmbed] = useState('')

  /**
   * Hook useEffect que establece la URL del video embebido de YouTube correspondiente.
   */
  useEffect(() => {
    const videoId = video.split('=')[1] // Se obtiene el ID del video desde la URL.
    setVideoEmbed(
      `https://www.youtube.com/embed/${videoId}?mute=1&controls=0&showinfo=0&rel=0&autoplay=1&loop=1&playlist=${videoId}`
    )
  }, [video])

  /**
   * Se renderiza el componente si se está mostrando el video.
   */

  return (
    <StyledContainer>
      <StyledIFrame {...props} src={videoEmbed} allow="autoplay" />
    </StyledContainer>
  )
}

export default VideoPlayer
